import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Video } from './video';

const routes: Routes = [
  {
    path: 'video',
    component: Video,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VideoRoutingModule {}
